package com.elan.edubridge.shared.domain.policy

import kotlin.math.ceil

/**
 * 구독 상태 띠의 **판정**. 문구는 플랫폼이 갖는다.
 *
 * 웹은 한국어 문자열을 HTML 에 박고, 안드로이드는 문자열 리소스로 로케일을 가른다 — 그 둘을 하나로
 * 합칠 수는 없다. 대신 "어떤 상태에서 띠를 띄우는가"와 "무료체험이 며칠 남았는가"는 제품 결정이라
 * 여기 한 곳에만 둔다. 두 벌이 되면 웹은 D-3 을, 앱은 D-2 를 보여 주는 날이 온다.
 *
 * 상태 문자열은 서버의 billing 모듈이 학원 문서 `subscription.state` 에 쓰는 값이다.
 * 모르는 값·정상(ACTIVE)·없음이면 띠를 띄우지 않는다 — 화면을 그대로 둔다.
 */
enum class SubscriptionBannerVariant { TRIAL, GRACE, SUSPENDED, WINDDOWN }

fun subscriptionBannerVariant(state: String?): SubscriptionBannerVariant? = when (state) {
    "TRIAL" -> SubscriptionBannerVariant.TRIAL
    "GRACE" -> SubscriptionBannerVariant.GRACE
    "SUSPENDED" -> SubscriptionBannerVariant.SUSPENDED
    "WINDDOWN" -> SubscriptionBannerVariant.WINDDOWN
    else -> null
}

private const val MILLIS_PER_DAY = 86_400_000.0

/**
 * 무료체험 남은 일수(올림, 음수는 0). 만료 시각이 없거나 계산할 수 없으면 null —
 * 그때는 날짜 없이 "무료체험 이용 중"만 보여 준다.
 */
fun trialDaysLeft(expiryTimeMillis: Double?, nowMillis: Double): Int? {
    val expiry = expiryTimeMillis?.takeIf { it.isFinite() } ?: return null
    if (!nowMillis.isFinite()) return null
    return ceil((expiry - nowMillis) / MILLIS_PER_DAY).toInt().coerceAtLeast(0)
}
